import {
  WIZARD_PROCESSING,
  WIZARD_PROCESSING_FAILURE,
  WIZARD_PROCESSING_SUCCESS,
} from "./wizard.actions";

const initial = {
  wizardProcessing: false,
};

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case WIZARD_PROCESSING:
      return {
        wizardProcessing: true,
      };
    case WIZARD_PROCESSING_SUCCESS:
    case WIZARD_PROCESSING_FAILURE:
      return {
        wizardProcessing: false,
      };
    default:
      return state;
  }
};
